import React from 'react';
const stats = [{
  num: '+18K',
  label: 'Coach e personal trainer utilizzano già i sistemi EduLabs nel mondo 🌍'
}, {
  num: '2.700+',
  label: 'Functional studio, PT e small group coach usano già questo metodo.'
}, {
  num: '420K+',
  label: "Workout e classi scaricate solo quest'anno."
}, {
  num: '93%',
  label: 'Riduzione media del tempo di programmazione settimanale.'
}];
const standards = [{
  title: 'Pubblico Target',
  desc: 'Creato per coach functional, PT, HIIT trainer e small group coach.'
}, {
  title: 'Sistema Completo',
  desc: 'Workout pronti, progressioni, mobility, women functional, planning professionale.'
}, {
  title: 'Multi-Dispositivo',
  desc: 'Compatibile con tablet, smartphone, PC e stampa professionale.'
}];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-14 sm:py-20 border-y border-border-light px-4 relative overflow-hidden" data-id="element-292">
      <div className="absolute inset-0 diagonal-stripe pointer-events-none" data-id="element-293"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-294">
        <p className="text-center text-primary font-bold uppercase tracking-[0.2em] text-xs sm:text-sm mb-10 flex items-center justify-center gap-3" data-id="element-295">
          <span className="h-px w-8 bg-primary/50" data-id="element-296"></span>
          La Community Functional Italiana
          <span className="h-px w-8 bg-primary/50" data-id="element-297"></span>
        </p>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-12 sm:mb-14" data-id="element-298">
          {stats.map((stat, i) => <div key={i} className="text-center border-r last:border-r-0 border-border-light px-2" data-id="element-299">
              <div className="font-display text-primary font-bold text-3xl sm:text-5xl mb-2 tracking-tight" data-id="element-300">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-301">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="border-t border-border-light pt-10" data-id="element-302">
          <p className="text-center text-white font-display font-bold uppercase tracking-[0.2em] text-sm sm:text-lg mb-7" data-id="element-303">
            Standard Professionale d'Élite
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5" data-id="element-304">
            {standards.map((s, i) => <div key={i} className="flex items-start gap-3 bg-bg-card border border-border-light rounded-sm px-5 py-4 hover:border-primary/40 transition-colors" data-id="element-305">
                <span className="w-6 h-6 rounded-sm bg-primary/15 border border-primary/40 text-primary font-bold text-sm flex items-center justify-center flex-shrink-0" data-id="element-306">
                  ✓
                </span>
                <div data-id="element-307">
                  <p className="text-white font-bold text-sm uppercase tracking-wide mb-1" data-id="element-308">
                    {s.title}
                  </p>
                  <p className="text-text-sec text-sm leading-snug" data-id="element-309">{s.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}